/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Prefs_Locale_HintInputs */

const cs_settings_prefs_locale_hint = /** @type {(inputs: Settings_Prefs_Locale_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jazyk rozhraní (čeština / angličtina).`)
};

const en_settings_prefs_locale_hint = /** @type {(inputs: Settings_Prefs_Locale_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interface language (Czech / English).`)
};

/**
* | output |
* | --- |
* | "Interface language (Czech / English)." |
*
* @param {Settings_Prefs_Locale_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_prefs_locale_hint = /** @type {((inputs?: Settings_Prefs_Locale_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Prefs_Locale_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_prefs_locale_hint(inputs)
	return cs_settings_prefs_locale_hint(inputs)
});